import { formatISO } from "date-fns";

import { CompanyFeedbackFilter } from "./components/CompanyFeedbackFilters";

import { CompanyFeedbackStreamFilters } from "../../api/services/defs/internal-api/feedback";

export const getFiltersForSearch = (
	searchTerm: string,
	additionalFilters: Partial<CompanyFeedbackFilter>,
	customFieldRefIds?: string[]
) => {
	const filters: any = {};
	if (additionalFilters?.author) {
		filters.author_id_eq = additionalFilters?.author?.id;
	}

	if (additionalFilters?.subject) {
		filters.subject_ids_in = [additionalFilters?.subject.id];
	}

	if (additionalFilters?.sharedWith) {
		filters.shared_with_in = [additionalFilters?.sharedWith];
	}

	if (additionalFilters?.responseToRequest) {
		filters.response_to_request_eq = additionalFilters?.responseToRequest === "true";
	}

	if (additionalFilters?.hashTags?.length) {
		filters.categories_in = additionalFilters.hashTags;
	}

	if (additionalFilters?.dateAfter) {
		filters.last_updated_gt = formatISO(additionalFilters.dateAfter);
	}

	if (additionalFilters?.dateBefore) {
		filters.last_updated_lt = formatISO(additionalFilters.dateBefore);
	}

	if (searchTerm) {
		filters["author.name_re"] = searchTerm;
		filters["subject.name_re"] = searchTerm;
		filters["content_re"] = searchTerm;
	}

	if (customFieldRefIds && customFieldRefIds.length > 0) {
		filters.custom_field_ids_in = customFieldRefIds;
	}

	return filters;
};

export const getFiltersForStream = (
	searchTerm: string,
	enabledCustomFieldRefIds: string[],
	filters: Partial<CompanyFeedbackFilter>
): CompanyFeedbackStreamFilters => {
	const f: CompanyFeedbackStreamFilters = {};
	if (filters?.author) f.authorId = filters.author.id;
	if (filters?.subject) f.subjectId = filters.subject.id;
	if (filters?.sharedWith) f.sharedWith = filters.sharedWith;
	if (filters?.hashTags?.length) f.categories = filters.hashTags;
	if (filters?.dateAfter) f.dateAfter = filters.dateAfter.toISOString();
	if (filters?.dateBefore) f.dateBefore = filters.dateBefore.toISOString();
	if (filters?.responseToRequest) f.responseToRequest = filters.responseToRequest === "true";
	if (searchTerm) f.searchTerm = searchTerm;
	if (enabledCustomFieldRefIds.length) f.customFieldIds = enabledCustomFieldRefIds;
	return f;
};

export const isReferenceTypeCustomField = (customField: any) => {
	return (
		customField.type === "person" ||
		customField.type === "people" ||
		customField.type === "department" ||
		customField.type === "role"
	);
};

// Migrate URLs written by the pre-PY-10080 filter panel, where employees were stored as
// { value, label } instead of the current { id, name }. Without this, bookmarked/shared
// URLs silently send author_id_eq=undefined to the search service.
export const normalizeCompanyFeedbackFilters = (
	filters: Partial<CompanyFeedbackFilter>
): Partial<CompanyFeedbackFilter> => {
	const normalized = { ...filters };
	for (const key of ["author", "subject"] as const) {
		const filter = filters[key] as any;
		if (filter && !filter.id && filter.value) {
			normalized[key] = { id: filter.value, name: filter.label ?? "" };
		}
	}
	return normalized;
};
